// Test Torque Credentials
export const TEST_TORQUE_PAY_CREDS_REQUEST = 'TEST_TORQUE_PAY_CREDS_REQUEST';
export const TEST_TORQUE_PAY_CREDS_SUCCESS = 'TEST_TORQUE_PAY_CREDS_SUCCESS';
export const TEST_TORQUE_PAY_CREDS_FAIL = 'TEST_TORQUE_PAY_CREDS_FAIL';
export const CLEAR_TEST_TORQUE_PAY_CREDS_STATE =
  'CLEAR_TEST_TORQUE_PAY_CREDS_STATE';

// Get Torque Credentials
export const GET_TORQUE_PAY_CREDS_REQUEST = 'GET_TORQUE_PAY_CREDS_REQUEST';
export const GET_TORQUE_PAY_CREDS_SUCCESS = 'GET_TORQUE_PAY_CREDS_SUCCESS';
export const GET_TORQUE_PAY_CREDS_FAIL = 'GET_TORQUE_PAY_CREDS_FAIL';

// Add Torque Credentials
export const ADD_TORQUE_PAY_CREDS_REQUEST = 'ADD_TORQUE_PAY_CREDS_REQUEST';
export const ADD_TORQUE_PAY_CREDS_SUCCESS = 'ADD_TORQUE_PAY_CREDS_SUCCESS';
export const ADD_TORQUE_PAY_CREDS_FAIL = 'ADD_TORQUE_PAY_CREDS_FAIL';

// Delete Torque Credentials
export const DELETE_TORQUE_PAY_CREDS_REQUEST =
  'DELETE_TORQUE_PAY_CREDS_REQUEST';
export const DELETE_TORQUE_PAY_CREDS_SUCCESS =
  'DELETE_TORQUE_PAY_CREDS_SUCCESS';
export const DELETE_TORQUE_PAY_CREDS_FAIL = 'DELETE_TORQUE_PAY_CREDS_FAIL';

// Add Torque Payment
export const MAKE_TORQUE_PAY_REQUEST = 'MAKE_TORQUE_PAY_REQUEST';
export const MAKE_TORQUE_PAY_SUCCESS = 'MAKE_TORQUE_PAY_SUCCESS';
export const MAKE_TORQUE_PAY_FAIL = 'MAKE_TORQUE_PAY_FAIL';

// Add Twilio Creds
export const ADD_TWILIO_CREDS_REQUEST = 'ADD_TWILIO_CREDS_REQUEST';
export const ADD_TWILIO_CREDS_SUCCESS = 'ADD_TWILIO_CREDS_SUCCESS';
export const ADD_TWILIO_CREDS_FAIL = 'ADD_TWILIO_CREDS_FAIL';

// Get Twilio Creds
export const GET_TWILIO_CREDS_REQUEST = 'GET_TWILIO_CREDS_REQUEST';
export const GET_TWILIO_CREDS_SUCCESS = 'GET_TWILIO_CREDS_SUCCESS';
export const GET_TWILIO_CREDS_FAIL = 'GET_TWILIO_CREDS_FAIL';
export const UPDATE_TWILIO_CREDS_FAIL = 'UPDATE_TWILIO_CREDS_FAIL';
export const UPDATE_TWILIO_STATE = 'UPDATE_TWILIO_STATE';

// delete Twilio Creds
export const DELETE_TWILIO_CREDS_REQUEST = 'DELETE_TWILIO_CREDS_REQUEST';
export const DELETE_TWILIO_CREDS_SUCCESS = 'DELETE_TWILIO_CREDS_SUCCESS';
export const DELETE_TWILIO_CREDS_FAIL = 'DELETE_TWILIO_CREDS_FAIL';

// clear twilio state
export const CLEAR_UPDATED_DATA_TWILIO = 'CLEAR_UPDATED_DATA_TWILIO';

// necPart typeS
// SETUP
export const SETUP_NEX_PART_CREDS_REQUEST = 'SETUP_NEX_PART_CREDS_REQUEST';
export const SETUP_NEX_PART_CREDS_SUCCESS = 'SETUP_NEX_PART_CREDS_SUCCESS';
export const SETUP_NEX_PART_CREDS_FAIL = 'SETUP_NEX_PART_CREDS_FAIL';

// get accounts
export const GET_NEX_PART_ACCOUNTS_REQUEST = 'GET_NEX_PART_ACCOUNTS_REQUEST';
export const GET_NEX_PART_ACCOUNTS_SUCCESS = 'GET_NEX_PART_ACCOUNTS_SUCCESS';
export const GET_NEX_PART_ACCOUNTS_FAIL = 'GET_NEX_PART_ACCOUNTS_FAIL';

// update nexPart account
export const UPDATE_NEX_PART_ACCOUNT_REQUEST =
  'UPDATE_NEX_PART_ACCOUNT_REQUEST';
export const UPDATE_NEX_PART_ACCOUNT_SUCCESS =
  'UPDATE_NEX_PART_ACCOUNT_SUCCESS';
export const UPDATE_NEX_PART_ACCOUNT_FAIL = 'UPDATE_NEX_PART_ACCOUNT_FAIL';

// clear nexPart state
export const CLEAR_NEX_PART_STATE = 'CLEAR_NEX_PART_STATE';

// PartsTech Types
// SETUP
export const SETUP_PART_TECH_CREDS_REQUEST = 'SETUP_PART_TECH_CREDS_REQUEST';
export const SETUP_PART_TECH_CREDS_SUCCESS = 'SETUP_PART_TECH_CREDS_SUCCESS';
export const SETUP_PART_TECH_CREDS_FAIL = 'SETUP_PART_TECH_CREDS_FAIL';
// get accounts
export const GET_PART_TECH_ACCOUNTS_REQUEST = 'GET_PART_TECH_ACCOUNTS_REQUEST';
export const GET_PART_TECH_ACCOUNTS_SUCCESS = 'GET_PART_TECH_ACCOUNTS_SUCCESS';
export const GET_PART_TECH_ACCOUNTS_FAIL = 'GET_PART_TECH_ACCOUNTS_FAIL';

// update nexPart account
export const UPDATE_PART_TECH_ACCOUNT_REQUEST =
  'UPDATE_PART_TECH_ACCOUNT_REQUEST';
export const UPDATE_PART_TECH_ACCOUNT_SUCCESS =
  'UPDATE_PART_TECH_ACCOUNT_SUCCESS';
export const UPDATE_PART_TECH_ACCOUNT_FAIL = 'UPDATE_NEX_PART_ACCOUNT_FAIL';
// clear nexPart state
export const CLEAR_PART_TECH_STATE = 'CLEAR_PART_TECH_STATE';
